import { render } from "./initialconfirm.vue?vue&type=template&id=e323e890"
import script from "./initialconfirm.vue?vue&type=script&lang=js"
export * from "./initialconfirm.vue?vue&type=script&lang=js"

import "./initialconfirm.vue?vue&type=style&index=0&id=e323e890&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__